'use strict';

(function ($, Drupal, drupalSettings, undefined) {

    var triggerPoint = $(window).innerHeight() * -.15;

    drupalSettings.swInstance = new ScrollWatch({
        watch: '.effect--reveal',
        watchOnce: true,
        ignoreClass: 'effect--animated',
        inViewClass: 'effect--in-view',
        watchOffsetYBottom: triggerPoint
    });

    Drupal.behaviors.mann_theme_scroll_watch = {
        attach: function attach(context, settings) {
            drupalSettings.swInstance.refresh();
        }
    };
})(jQuery, Drupal, drupalSettings);